import { ProductCategoriesLink } from "components/Navbar/types"
import { GlassesProduct, ProductV2 } from "types"

export interface ProductsCategory {
  to: ProductCategoriesLink
  label: string
}

export interface IResponseProductsCategories {
  id: string
  name: string
}

export interface IGlassesRenderingOptions {
  bodyGloss: number
  lensesGloss: number
  transparency: number
  positionAccuracy: number
  scale: number
}

export interface ProductType {
  id: string
  name: string
  externalId?: string
}

export interface ProductState {
  productsCategories: ProductsCategory[]
  productsCategoriesLoading: boolean
  product: ProductV2
  glasses: GlassesProduct
  types: ProductType[]
}

export enum ProductTypeName {
  Eyeliner = "EYELINER",
  Eyeshadow = "EYESHADOW",
  Eyelashes = "EYELASHES",
  Eyebrows = "EYEBROWS",
  Mascara = "MASCARA",
  Blush = "BLUSH",
  Foundation = "FOUNDATION",

  FoundationClear = "FOUNDATION_CLEAR",
  FoundationMediumClear = "FOUNDATION_MEDIUM_CLEAR",
  FoundationMedium = "FOUNDATION_MEDIUM",
  FoundationMediumDark = "FOUNDATION_MEDIUM_DARK",
  FoundationDark = "FOUNDATION_DARK",

  Bronzer = "BRONZER",

  Lipstick = "LIPSTICK",
  Highlighter = "HIGHLIGHTER",
  Contour = "CONTOUR",
  Concealer = "CONCEALER",
  Lipliner = "LIPLINER",
  Gloss = "GLOSS",
  BbСсCream = "BB_CC_CREAM",
  Powder = "POWDER",
  EyesAndBrows = "EYES_AND_BROWS",
  Cheeks = "CHEEKS",
  Cleansers = "CLEANSERS",

  EyeLenses = "EYE_LENSES",

  AntiAcne = "ANTI_ACNE",
  Toner = "TONER",
  Exfolitators = "EXFOLITATORS",
  Serum = "SERUM",
  FacialMask = "FACIAL_MASK",
  EyeCream = "EYE_CREAM",
  HydratingCream = "HYDRATING_CREAM",
  AntiWrinkle = "ANTI_WRINKLE",
  AntiAgeingCream = "ANTI_AGEING_CREAM",
  Glasses = "GLASSES",
  Hairs = "HAIRS",
}
